import NotFound from '@/views/common/NotFound.vue'
import Layout from '@/layout/index.vue'
import Login from '@/views/Login/index.vue'
import Active from '@/views/Active/activeCode.vue'
import Trial from '@/views/Trial/Trial.vue'

export default [{
    path: '/login',
    component: Login,
    meta: {
      module: '登录',
      title: 'login'
    }
  },
  {
    path: '/',
    component: Layout,
    redirect: '/operations',
    children: [{
        path: 'operations',
        name: 'Operations',
        component: () => import('../views/Operations/index.vue'),
        meta: {
          module: '运营分析',
          title: '运营分析'
        }
      },
      {
        path: 'emails',
        name: 'AlertEmail',
        component: () => import('../views/AlertEmail/index.vue'),
        meta: {
          module: '告警邮箱',
          title: '告警邮箱'
        }
      },
      {
        path: 'manage',
        name: 'Manage',
        component: () => import('../views/Manage/index.vue'),
        meta: {
          module: 'License管理',
          title: 'License管理'
        }
      },
      {
        path: 'statistics',
        name: 'Statistics',
        component: () => import('../views/Statistics'),
        meta: {
          module: 'License 统计',
          title: 'License 统计总览'
        }
      },
      {
        path: 'logs',
        name: 'Logs',
        component: () => import('../views/Logs'),
        meta: {
          module: '操作',
          title: '操作日志'
        }
      },
    ]
  },
  {
    path: '/active',
    component: Active,
    meta: {
      module: '激活',
      title: '激活'
    }
  },
  {
    path: '/trial',
    component: Trial,
    meta: {
      module: '试用',
      title: '试用'
    }
  },
  {
    path: '/404',
    component: NotFound
  },
  {
    path: '*',
    redirect: '/404'
  }
]